<template >
	<div class="list-layout" ref="contentRef" >
		<div v-for="(item,index) in list" :key="index" class="item">
			<span class="article-title" @click="toArticle(item)">
				{{item.title}}
				<el-tag size='mini' v-if="item.status.code!=1" style="margin-left:10px">
					<!-- 优先显示发布状态， -->
					{{item.status.code==1?item.status.description:item.approveStatus && item.approveStatus.code>0?item.approveStatus.description:item.status.description}}
				</el-tag>
			</span>
			<div>
				<span>{{item.createTime}}</span>
				<template v-if="currentUser.id==item.author.id">
					<el-button style="margin-left:10px;padding:5 10px" size='mini' v-if="item.status.code!=1"
						@click="toEditor(item)">修改</el-button>
					<el-button size='mini' style="padding:5 10px"
						v-if="item.status.code==0 && (!item.approveStatus || item.approveStatus.code==3) "
						@click="release(item)">发布</el-button>
					<el-button size='mini' style="padding:5 10px"
						v-if="item.status.code!=1 && item.approveStatus && [1,2].includes(item.approveStatus.code)"
						@click="revoke(item)">撤回
					</el-button>
					<el-button size='mini' style="padding:5 10px"
						v-if="item.status.code==0 && (!item.approveStatus||item.approveStatus.code==3)"
						@click="remove(item)">删除
					</el-button>
				</template>
			</div>
		</div>
		<el-pagination v-if="list.length>0" background layout="prev, pager, next"
			:page-size="filters.pageSize" :current-page="filters.pageNum" :total="total"
			@current-change="getContentList" />
	</div>
</template>
<script>
    import articleListMixin from './article-list-mixin'
	export default {
        mixins:[articleListMixin],
        data() {
            return {
                
            }
        },
		mounted(){
			const pageSize = Math.floor((this.$refs.contentRef.clientHeight - 100) / 52)
			this.filters.pageSize=pageSize
		}
	}
</script>

<style lang="scss" scoped>
	.item {
		border-bottom: 1px dashed #dcdfe6;
		padding: 15px 0px;
		display: flex;
		justify-content: space-between;
	}
	.list-layout {
		
		width: 100%;
		font-size: 14px;
		

	}
	.article-title {
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/views/party-build/article-list-layout.vue